import React from "react";
import { useTheme } from "@mui/material/styles";
import FormControl from "@mui/material/FormControl";
import TextField from "@mui/material/TextField";
import SearchIcon from "@mui/icons-material/Search";
import InputAdornment from "@mui/material/InputAdornment";

export default function SearchBar(props) {
  const theme = useTheme();
  const { onUpdateSearch, search } = props;
  const [searchValue, setSearchValue] = React.useState(search || "");

  const styles = {
    root: {
      width: "100%",
      padding: 10,
    },
    search: {
      marginTop: theme.spacing(2.5), // équivaut à 20px
      marginBottom: theme.spacing(2.5),
    },
  };

  const handleChangeValue = (e) => {
    const value = e.target.value;
    setSearchValue(value);
    onUpdateSearch?.(value);
  };

  return (
    <div style={styles.root}>
      <FormControl fullWidth noValidate autoComplete="off">
        <TextField
          variant="outlined"
          label="Rechercher"
          id="search"
          value={searchValue}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
          }}
          onChange={handleChangeValue}
          sx={styles.search}
        />
      </FormControl>
    </div>
  );
}
